// GET /v_event_last_summary?select=*,lpr_group(name),lpr_subtenant(name),lpr_entity(name)

import axios from "../../../../api/axiosSetup3";

/* 
SELECT 
	s.*, 
	e.name,
	g.name,
	sub.name
FROM v_event_last_summary s
JOIN lpr_group g USING(customer_id, group_id)
LEFT JOIN lpr_subtenant sub USING(customer_id, subtenant_id)
JOIN lpr_entity e USING(entity_id)
WHERE s.customer_id = 256
*/

const getEventLastSummary_ = async (): Promise<any[]> => {
    const res = await axios.get<any[]>('/v_event_last_summary?select=*,lpr_group(name),lpr_subtenant(name),lpr_entity(name)');
    return res.data;
};

// 1. Описываем интерфейс исходного ответа от PostgREST
interface PostgrestEventResponse {
  id: number;
  cnt_enter: number;
  cnt_exit: number;
  difffact: number;
  lpr_group: { name: string } | null;
  lpr_subtenant: { name: string } | null;
  lpr_entity: { name: string } | null;
}

// 2. Описываем интерфейс целевой (плоской) таблицы
export interface FlatEventSummary {
  id: number;
  cnt_enter: number;
  cnt_exit: number;
  difffact: number;
  lpr_group_name: string | null;
  lpr_subtenant_name: string | null;
  lpr_entity_name: string | null;
}

export interface Event {
  id: number;
  ts_start: string;
  lpr_entity_name: string;
  lpr_group_name: string;
  lpr_subtenant_name: string | null;
  registration_number: string;
  matched_number: string | null;
  car_brand: string;
  car_owmer: string;
  group_id: number;
  entity_id_1: number;
  subtenant_id: number | null;
}

async function getEventLastSummary(): Promise<FlatEventSummary[]> {
  const res = await axios.get<PostgrestEventResponse[]>(
    '/v_event_last_summary?select=*,lpr_group(name),lpr_subtenant(name),lpr_entity(name)'
  );

  return res.data.map(({ lpr_group, lpr_subtenant, lpr_entity, ...item }) => ({
    ...item,
    lpr_group_name: lpr_group?.name ?? null,
    lpr_subtenant_name: lpr_subtenant?.name ?? null,
    lpr_entity_name: lpr_entity?.name ?? null,
  }));
}

async function getEventLastIn( params : { moment: string, period_days: number }  ): Promise<Event[]> {
    const res = await axios.get<Event[]>(`/rpc/sf_event_last_in_2?moment=${params.moment}&period_days=${params.period_days}`, );
    return res.data;
}

export const reportApi = {
    getEventLastSummary,
    getEventLastIn,
};